export const EMAIL = "email";
export const PASSWORD = "password";
export const CHECK_SAVE_EMAIL = "checkSaveEmail";
